import { render, staticRenderFns } from "./OrganizationMembers.vue?vue&type=template&id=40140aae"
import script from "./OrganizationMembers.vue?vue&type=script&lang=js"
export * from "./OrganizationMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports